export enum ApplicationFinancingType {
  lease = 'lease',
  installmentLoan = 'installmentLoan',
}
